import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation } from 'react-query';
import { UpdateVideoParams } from './types';
import { useTranslation } from 'react-i18next';

export const updateVideo = async ({
  videoId,
  videoBody,
}: UpdateVideoParams) => {
  const response = await EXPRESS_API.put(`/videos/${videoId}`, videoBody);
  return response.data;
};

export const useUpdateVideoMutation = () => {
  const { t } = useTranslation();
  return useMutation((data: UpdateVideoParams) => updateVideo(data), {
    onError: () => {
      errorToast({
        title: t('Failed to update video. Please try again later.'),
      });
    },
  });
};
